import { makeAutoObservable, runInAction } from "mobx";
import { USER_STATUS_ENUM } from "interfaces";
import { getUserById } from "services";
import { NormalizedError } from "services/api/errorHandler";
import { statusFetching } from "services/authClient/constants/types";
import { components } from "types/openapi";

export class UserCardStore {
  public card: components["schemas"]["UserDto"] = {
    id: "",
    companyUserDto: [],
    surname: "",
    name: "",
    secondName: "",
    phone: "",
    email: "",
    status: USER_STATUS_ENUM.DRAFT,
    createdAt: "",
    statusDate: "",
    roles: [],
  };
  public fetchStatus: statusFetching = "init";
  public fetchError?: NormalizedError;

  constructor() {
    makeAutoObservable(this);
  }

  get isPending() {
    return this.fetchStatus === "fetching";
  }

  fetchCardById = async (id: string) => {
    this.fetchStatus = "fetching";
    this.fetchError = undefined;

    return getUserById({ id })
      .then((res) => {
        runInAction(() => {
          this.card = res;
          this.fetchStatus = "success";
        });
      })
      .catch((error: NormalizedError) => {
        runInAction(() => {
          this.fetchStatus = "error";
          this.fetchError = error;
        });
      });
  };
}
